
import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import { fetchPractice, checkIfSessionAssessment } from "../../actions/index"
import { adminDeletePractice } from "../../actions/admin"

import Tick from '../ui/Tick.jsx';
import CheckBox from '../ui/CheckBox.jsx';
import TextareaAutosize from 'react-autosize-textarea';
import { savePractice } from '../../actions/practiceAdmin'

import { setTitle } from "../../actions/index"
import deleteImg from "../../images/icons/delete_forever_black.svg"
import { practices } from '../../reducers'


//import styles
//import './styles/AdminVideos.scss';

const saveStyle = {
	'zIndex': 2,
	'position': 'relative'
}


@connect((store) => {
	return {
		User: store.User.User,
		practices: store.practices,
		app: store.app,
		practice_types: store.practice_types
	}
})
class AdminPractice extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			practice: {},
			saved: true,
			hasSessionsAssesments: true
		}
		this.save = this.save.bind(this)
		this.handleInputChange = this.handleInputChange.bind(this)
		this.handleToggleAtt = this.handleToggleAtt.bind(this)
		this.approve = this.approve.bind(this)
		this.handleSlugChange = this.handleSlugChange.bind(this)
		this.getPractice = this.getPractice.bind(this)
		this.setSlug = this.setSlug.bind(this)
		this.handleDelete = this.handleDelete.bind(this)
		this.handleProfessionChange = this.handleProfessionChange.bind(this)
	}

	componentDidMount() {
		this.props.dispatch(setTitle('Admin: Practice'));
	}

	componentDidUpdate(nextProps) {
		const { practice } = this.state
		if (nextProps.params.id !== practice._id) {
			// id has changed - get new
			this.getPractice(nextProps.params.id)
		}
	}

	getPractice(id) {
		if (this.props.User.token && this.props.User.name != '') {
			this.props.dispatch(fetchPractice(id))
				.then(practice => {
					this.setState({
						practice: practice
					})
				});

			this.props.dispatch(checkIfSessionAssessment(id))
				.then(bool => {
					this.setState({
						hasSessionsAssesments: bool.data.found
					})
				})
		}		
		
	}

	save() {
		const { dispatch } = this.props;
		const { practice } = this.state
		dispatch(savePractice(practice._id, practice))
			.then((a) => {
				this.setState({
					"saved": true,
					practice: a.payload
				})
			})
	}

	approve() {
		this.setState({
			practice: { ...this.state.practice, approved: !this.state.practice.approved },
			saved: false
		})
	}

	handleDelete() {
		const { _id } = this.state.practice
		const { router } = this.props
		if (confirm('Really delete this practice??')) {
			this.props.dispatch(adminDeletePractice(_id))
			router.replace('/admin/practices')
		}
	}

	handleInputChange(e, field) {
		this.setState({
			practice: { ...this.state.practice, [field]: e.target.value },
			saved: false
		})
	}

	handleToggleAtt(field) {
		let practice = this.state.practice;
		practice[field] = !practice[field];
		console.log(practice);
		this.setState({
			user: practice,
			saved: false
		});
	}

	handleProfessionChange(e) {
		this.setState({ 
			practice: {
				...this.state.practice, practice_type:e.target.value
			}, 
			saved: false
		});
	}

	makeSlug(str) {
		return str.toLowerCase()
			.replace(/\s+/g, '-')           // Replace spaces with -
			.replace(/[^\w\-]+/g, '')       // Remove all non-word chars
			.replace(/\-\-+/g, '-')         // Replace multiple - with single -
			.replace(/^-+/, '')             // Trim - from start of text
		//  .replace(/-+$/, '');            // Trim - from end of text
	}

	setSlug(slug) {
		if (slug && slug !== "") {
			this.setState({
				practice: { ...this.state.practice, slug: slug },
				saved: false
			})
		}
	}

	handleSlugChange(e) {
		const slug = this.makeSlug(e.target.value.toString())
		this.setState({
			practice: { ...this.state.practice, slug: slug },
			'saved': false
		})
	}

	render() {
		const { practice, saved, hasSessionsAssesments } = this.state

		return (
   			<main className="main adminPracticeSingleView mb8">
				<div ref="page" >
					<div className="card padding">
						<p>Admin needs to set a slug (url) and approve the practice</p>
					</div>
					<div className="page">
						<a href="/admin/practices" className="backButton">&larr; Back</a>
						<h5>
							{practice.name}
						</h5>
						<br />

						<div className="right" style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							justifyItems: 'center'
						}}>
							<Tick label="Approved" on={practice.approved} onClick={this.approve}></Tick>
							<img title="Delete" src={deleteImg} style={{ opacity: 0.5, cursor: 'pointer' }}
								onClick={this.handleDelete} />
						</div>
						<br />
						{practice.owner ? (
							<p>
								<b>Owner</b><br />
								<a href={`/profile/${practice.owner.uid}`}>{practice.owner.name}</a> <br />
								{practice.owner.email ? <a href="mailto:{practice.owner.email}">{practice.owner.email}</a> : null}

							</p>
						) : null}

						<br />
						<div className="md-body1 form-field">
							<label>Practice Healthcare Area</label>
            					<select
								disabled={hasSessionsAssesments}
								className="md-input md-title mx0"
								value={practice.practice_type}
								onChange={e => this.handleProfessionChange(e)}
							>
								{(this.props.practice_types && this.props.practice_types.length) ? this.props.practice_types.map(type => (
									<option key={type.id} value={type.id}>
										{type.practice_type}
									</option>
								)):''}
							</select>
						</div>
						<div></div>
						<div className="md-body1 form-field">
							<label>Practice Name</label>
							<div>
								<input className="md-input md-title"
									autoComplete="off"
									onChange={(e) => this.handleInputChange(e, 'name')}
									value={practice.name}
									type="text" placeholder="Name of Practice" />
							</div>
						</div>
						<div className="md-body1 form-field">
							<label>
								Slug
							</label>
							<div>
								{practice.tempSlug ? (
									<p>
										Assign a slug (suggestion: &nbsp;
										<b><a className="link" onClick={() => {
											const str = this.makeSlug(practice.name)
											this.setSlug(str)
										}
										}>
											{this.makeSlug(practice.name)}
										</a></b>)
									</p>
								) : null}

								<span >/practice/</span>
								<input style={{
									width: '10em'
								}} className="md-input md-title"
									autoComplete="off"
									onChange={(e) => this.handleSlugChange(e)}
									value={practice.slug}
									type="text" placeholder="Slug" />
							</div>
						</div>

						<div className="md-body1 form-field">
							<label>HPCSA Number</label>
							<div>
								<input className="md-input md-title"
									autoComplete="off"
									onChange={(e) => this.handleInputChange(e, 'HPCSA')}
									value={practice.HPCSA}
									type="text" placeholder="HPCSA Number" />
							</div>
						</div>


						<div className="md-body1 form-field">
							<label>Description</label>

							<div>
								<TextareaAutosize className="md-input" placeholder="Write a description of the practice ..."
									onChange={e => this.handleInputChange(e, 'description')}
									value={practice.description} />
							</div>
						</div>
						<h5>Contacts</h5>
						<div className="md-body1 form-field">
							<label>Phone</label>
							<div>
								<input className="md-input md-title"
									autoComplete="off"
									onChange={(e) => this.handleInputChange(e, 'phone')}
									value={practice.phone}
									type="text" placeholder="Phone" />
							</div>
						</div>
						<div className="md-body1 form-field">
							<label>Mobile</label>
							<div><input className="md-input md-title"
								autoComplete="off"
								onChange={(e) => this.handleInputChange(e, 'mobile')}
								value={practice.mobile}
								type="text" placeholder="Mobile" /></div>
						</div>
						<div className="md-body1 form-field">
							<label>Email</label>
							<div><input className="md-input md-title"
								autoComplete="off"
								onChange={(e) => this.handleInputChange(e, 'email')}
								value={practice.email}
								type="email" placeholder="Email" /></div>
						</div>
						<div className="md-body1 form-field">
							<label>www</label>
							<div><input className="md-input md-title"
								autoComplete="off"
								onChange={(e) => this.handleInputChange(e, 'www')}
								value={practice.www}
								type="text" placeholder="Web site" /></div>
						</div>
						<h5>Address</h5>

						<div className="md-body1 form-field">
							<label>Address</label>
							<div>
								<input className="md-input md-title"
									autoComplete="off"
									onChange={(e) => this.handleInputChange(e, 'address1')}
									value={practice.address1}
									type="text" placeholder="" />
							</div>
						</div>
						<div className="md-body1 form-field">
							<label>Address 2</label>
							<div><input className="md-input md-title"
								autoComplete="off"
								onChange={(e) => this.handleInputChange(e, 'address2')}
								value={practice.address2}
								type="text" placeholder="" /></div>
						</div>
						<div className="md-body1 form-field">
							<label>City</label>
							<div><input className="md-input md-title"
								autoComplete="off"
								onChange={(e) => this.handleInputChange(e, 'city')}
								value={practice.city}
								type="email" placeholder="City" /></div>
						</div>
						<div className="md-body1 form-field">
							<label>State/Provence</label>
							<div><input className="md-input md-title"
								autoComplete="off"
								onChange={(e) => this.handleInputChange(e, 'state')}
								value={practice.state}
								type="text" placeholder="Province/state" /></div>
						</div>
						<div className="md-body1 form-field">
							<label>Postal code</label>
							<div><input className="md-input md-title"
								autoComplete="off"
								onChange={(e) => this.handleInputChange(e, 'postCode')}
								value={practice.postCode}
								type="text" placeholder="Postal/zip code" /></div>
						</div>
						<div className="md-body1 form-field">
							<label>Country</label>
							<div><input className="md-input md-title"
								autoComplete="off"
								onChange={(e) => this.handleInputChange(e, 'country')}
								value={practice.country}
								type="text" placeholder="Country" /></div>
						</div>
						<h5>Add Ons</h5>
						<div className="md-body1 form-field">
							<div>
								<span onClick={() => { this.handleToggleAtt('mediaStorageAddonEnabled') }}>
									<CheckBox label="Enable Media Uploads & Storage" on={practice.mediaStorageAddonEnabled} ></CheckBox>
								</span>
							</div>
						</div>
					</div>
					<button disabled={saved} className="md-button md-primary right link" style={saveStyle} onClick={this.save}>Save</button>
					<br /><br /><br /><br />
				</div>
			</main>
		)
	}
}


export default withRouter(AdminPractice);



// WEBPACK FOOTER //
// ./src/components/admin/AdminPractice.jsx